<template>
    <div class="row mx-0">
        <div 
            class="col-md-4 col-lg-3 "
            :class="{'pr-0' : $breakpoint.lgAndDown && !$breakpoint.smAndDown}"
        >
            <all-messages />
        </div>
        <div class="col-md-8 col-lg-9">
            <button 
                class="btn btn-confirm float-right"
                :class="[ $breakpoint.smAndDown ? 'btn-icon btn-new--mobile' : 'mt-2']"
                @click="startConversation"
            >
                <i v-if="$breakpoint.smAndDown" class="fas fa-plus" icon="plus" />
                <span v-else>Start a conversation</span>
            </button>
            
            <div class="modal right fade" v-if="$breakpoint.smAndDown" id="myConversation" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content pb-0">
                        <button class="modal-close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-lg fa-times"></i>
                        </button> 
                        <conversation v-if="getConversationId"/>
                    </div>
                </div>
            </div>
            <div v-else>
                <conversation v-if="getConversationId"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import breakpoint from '@/mixins/index';

import AllMessages from '@/components/ChatService/AllMessages.vue'
import Conversation from '@/components/ChatService/Conversation.vue'
import StartConversation from '@/components/ChatService/StartConversation.vue'


export default {
    mixins: [breakpoint],
    components: {
        AllMessages,
        Conversation,
        StartConversation,
    },
    computed: {
        ...mapState('conversation',['conversationSelected','searchModal','newConversationStarted']),
        ...mapState('login', ['userLoggedIn']),
        ...mapGetters('conversation', ['getConversationId']),
        ...mapGetters('login', ['getAccountType']),
        openStartConversation: function(){
            if (this.searchModal){
                let element = this.$root.$refs.startConversation.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        }
    },
    updated() {
        // if (this.$breakpoint.smAndDown && this.getConversationId) {
        //     // $('#conversation').modal('show')
        // }
    },
    methods:{
        ...mapActions('conversation',['showSearchModal','hideConversations']),
        startConversation(){
            //open the modal to search the user for a new chat
            if(!this.searchModal){
                this.showSearchModal()
                // const el = document.body
                // el.classList.add('modal-open')
            }
        },        
    },
    watch: {
        openStartConversation(){}
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>
